import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="bg-zinc-950	 p-4 text-white text-center">
      <h3 className="text-xl font-bold">Footer</h3>
    </footer>
  );
};

export default Footer;
